<p *ngIf="props.heading" class="mb-2" [innerHTML]="props.heading"></p>

<label
  *ngIf="props.label && props.hideLabel !== true && props.useExternalLabel"
  for="{{ field.id }}"
  class="block external-label"
  >{{ props.label | castObservable | async }}
  <span
    *ngIf="props.required && props.hideRequiredMarker !== true"
    aria-hidden="true"
    class="mat-form-field-required-marker"
    >*</span
  ></label
>
<mat-form-field
  class="pt-_5"
  [appearance]="props.appearance || 'outline'"
  [color]="props.color ?? 'primary'"
  [floatLabel]="props.floatLabel || 'always'"
  [hideRequiredMarker]="true"
  [ngClass]="props.className"
  [subscriptSizing]="props.subscriptSizing || 'fixed'"
  [class.mat-mdc-form-field-readonly]="props.readonly === true"
>
  <ng-container #fieldComponent></ng-container>
  <mat-label
    *ngIf="props.label && props.hideLabel !== true && !props.useExternalLabel"
  >
    {{ props.label | castObservable | async }}
    <span
      *ngIf="props.required && props.hideRequiredMarker !== true"
      aria-hidden="true"
      class="mat-form-field-required-marker"
      >*</span
    >
  </mat-label>

  <lui-form-field-indicator
    [class.d-none]="!props.hideIndicator"
  ></lui-form-field-indicator>

  <ng-container *ngIf="props.textPrefix" matTextPrefix>
    <ng-container
      [ngTemplateOutletContext]="{ field: field }"
      [ngTemplateOutlet]="props.textPrefix"
    ></ng-container>
  </ng-container>
  <ng-container *ngIf="props.prefix" matPrefix>
    <ng-container
      [ngTemplateOutletContext]="{ field: field }"
      [ngTemplateOutlet]="props.prefix"
    ></ng-container>
  </ng-container>
  <ng-container *ngIf="props.textSuffix" matTextSuffix>
    <ng-container
      [ngTemplateOutletContext]="{ field: field }"
      [ngTemplateOutlet]="props.textSuffix"
    ></ng-container>
  </ng-container>
  <ng-container *ngIf="props.suffix" matSuffix>
    <ng-container
      [ngTemplateOutletContext]="{ field: field }"
      [ngTemplateOutlet]="props.suffix"
    ></ng-container>
  </ng-container>
  <mat-error>
    <formly-validation-message [field]="field"></formly-validation-message>
  </mat-error>
  <mat-hint *ngIf="props.description || props.hintStart as hint">
    <ng-container
      [ngTemplateOutletContext]="{ content: hint }"
      [ngTemplateOutlet]="stringOrTemplate"
    >
    </ng-container>
  </mat-hint>
  <mat-hint *ngIf="props.hintEnd as hintEnd" align="end">
    <ng-container
      [ngTemplateOutletContext]="{ content: hintEnd }"
      [ngTemplateOutlet]="stringOrTemplate"
    >
    </ng-container>
  </mat-hint>
</mat-form-field>
<ng-template #stringOrTemplate let-content="content">
  <ng-container *ngIf="!content.createEmbeddedView; else template">{{
    content
  }}</ng-container>
  <ng-template #template>
    <ng-container
      [ngTemplateOutletContext]="{ field: field }"
      [ngTemplateOutlet]="content"
    ></ng-container>
  </ng-template>
</ng-template>
